import React, { useEffect, useState } from "react";
import { useField } from "formik";

import useInView from "src/shared/utilities/useInView";

import analytics from "../../utilities/analytics";
import useActiveExperts from "../../utilities/hooks/useActiveExperts";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import useOpenDealsModal from "../../utilities/hooks/useOpenDealsModal";
import ExpertField from "../ExpertField";
import * as S from "./styled";

const ExpertContainer = () => {
  const { expert, loading } = useActiveExperts();
  const { id: contactId, is_pro: isPro } = expert?.contact ?? {};
  const { listingId } = useFeatureState();
  const handleOpenDealsModal = useOpenDealsModal();
  const [listShown, setListShown] = useState(false);
  const { inView, ref } = useInView();
  const [, , { setValue: setExpert }] = useField("expert");

  useEffect(() => {
    if (inView) {
      setListShown(true);
    }

    if (inView && !listShown) {
      analytics({
        action: "impressions_for_building_expert",
        isHdp: Boolean(listingId),
        label: `expert_contact_id=${contactId}|pro=${isPro}`
      });
    }
  }, [expert, listShown, inView]);

  const handleExpertChoice = () => {
    setExpert(expert);

    analytics({
      isHdp: Boolean(listingId),
      label: `select_building_expert|expert_contact_id=${contactId}`
    });
  };

  if (loading || !expert) return null;

  return (
    <S.ExpertContainer ref={ref} data-testid="expert-container">
      <ExpertField
        key={contactId}
        expert={expert}
        name="contact_id"
        onChange={handleExpertChoice}
        onInfoClick={handleOpenDealsModal}
        value={contactId}
      />
    </S.ExpertContainer>
  );
};

export default ExpertContainer;
